export const FirebaseConfig = {
	"projectId": "fireride-app",
	"appId": "1:580060826841:web:2003560d30a5dfaae182c8",
	"databaseURL": "https://fireride-app-default-rtdb.firebaseio.com",
	"storageBucket": "fireride-app.firebasestorage.app",
	"apiKey": "AIzaSyAMowWXs2kvc_6HJzja1yU3utii33VwHr4",
	"authDomain": "fireride-app.firebaseapp.com",
	"messagingSenderId": "580060826841",
	"measurementId": "G-0LSYBVNKTM"
};